import {makeAutoObservable, runInAction} from "mobx";
import services from "../services";
import { extractErrorMessage } from "../utils/helpers";
import { generateLoadEntity } from "../utils/mobx";

class TestStore {
  testLoading = null;
  testInfo = null;

  submitAnswerResult = null;
  submittingAnswer = null;

  testError = null;

  constructor(authStore) {
    makeAutoObservable(this);
    this.authStore = authStore;
  }

  setError(error, type = "testError") {
    error = extractErrorMessage(error);
    this.error = error;
  }
  resetTest() {
    this.testLoading = null;
    this.testInfo.isAnswered = false;
    if ( this.submitAnswerResult )
      this.submitAnswerResult.isAnswered = false;
    this.submitAnswerResult = null;
    this.submittingAnswer = null;
    this.testError = null;
  }

  getTestByIdLabel = generateLoadEntity(
    "testInfo",
    this,
    "testLoading",
    ({ lang, testIdLabel }) => {
      return services.TestService.getTestByIdLabel(testIdLabel, lang);
    },
    "testInfo"
  );

  submitAnswer = generateLoadEntity(
    "testInfo",
    this,
    "submittingAnswer",
    async ({ testIdLabel, lang, answers }) => {
      const result =  await services.TestService.submitAnswer(testIdLabel, lang, answers);
      await this.authStore.pullUser()
      runInAction(() => {
        Object.assign( this.testInfo, result);
      })

    },

  );
}

export default TestStore;
